import { get, post, remove } from "./api";
import routes from "./end-points";

export const adminNotificationsApi = {
    initAll: () => get(routes.adminNotification.initAll),
    send: (dto) => post(routes.adminNotification.send, dto),
    delete: (id) => remove(routes.adminNotification.delete(id)),
};
